import AspectRatioPlaceholder from '@rio-cloud/rio-uikit/components/aspectRatioPlaceholder/AspectRatioPlaceholder';
import ImagePreloader from '@rio-cloud/rio-uikit/components/preloader/ImagePreloader';
import Spinner from '@rio-cloud/rio-uikit/Spinner';

const fallback = (
    <AspectRatioPlaceholder width={1000} height={562}>
        <div className='text-size-h3 display-grid place-items-center position-absolute inset-0'>
            <span className='uikit-icon icon-missing text-size-200pct text-color-gray' />
        </div>
    </AspectRatioPlaceholder>
);

export const RioImage = ({ imageSrc }: { imageSrc: string }) => {
    return (
        <ImagePreloader src={imageSrc}>
            {({ status, image }) => {
                switch (status) {
                    case 'FAILED':
                        return fallback;

                    case 'LOADED':
                        return <img src={image.src} className='img-responsive ani-fade-in' alt='' />;

                    default:
                        return (
                            <div className='display-grid place-items-center position-absolute inset-0'>
                                <Spinner isInverse={false} />
                            </div>
                        );
                }
            }}
        </ImagePreloader>
    );
};
